export const isEmployee = ({ rootGetters }) => rootGetters['user/isEmployee']
export const isProvider = ({ rootGetters }) => rootGetters['user/isProvider']
